<script lang="ts">
	import { slideIn } from '$lib/actions/slideIn';
	import Checkmark from '$lib/icons/checkmark.svelte';
	import StarRating from '$lib/review/starRating.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { ISbStoryData } from '@storyblok/js';
	import type { CardCategory } from './types';

	interface Props {
		content: ISbStoryData<{ quote: string; name: string }>['content'];
		delay?: number;
		threshold?: number;
		category: CardCategory;
	}

	let { content, delay = 100, threshold = 0.3 }: Props = $props();
</script>

<a
	use:editable={content}
	use:slideIn={{ delay, threshold }}
	class="block opacity-[0.01]"
	href="/reviews"
	target="_blank"
>
	<div class="flex flex-col gap-y-4 rounded-xl bg-[#FAF9F9] px-3 py-4 lg:p-5">
		<StarRating starClass="h-6 w-6" score={5} />

		<p class="flex -translate-x-[6px] text-[16px]/[140%] text-brown-1 max-lg:tracking-[-.16px]">
			<span>“</span>
			<span>
				{content.quote}”
			</span>
		</p>

		<div class="flex items-center gap-x-3">
			<div
				class="relative flex h-9 w-9 items-center justify-center rounded-full bg-brown-1 text-white"
			>
				{content.name.charAt(0)}

				<div
					class="absolute bottom-0 right-0 flex h-5 w-5 translate-x-1 translate-y-1 items-center justify-center rounded-full border border-white bg-green-4"
				>
					<Checkmark class="h-[14px] w-[14px]" />
				</div>
			</div>

			<div class="text-brown-1">
				<p class="text-[14px]/[160%]">{content.name}</p>
				<p class="text-[14px]/[112%] text-brown-4 max-lg:tracking-[.12px] lg:text-[14px]/[160%]">
					Verified buyer
				</p>
			</div>
		</div>
	</div>
</a>
